// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#settingsContent[data-v-5308a208] {\n    padding: 0px 30px;\n}\n.invisible[data-v-5308a208] {\n    display: none;\n}\ninput[type=\"file\"][data-v-5308a208] {\n    display: none;\n}\n.subNote[data-v-5308a208]{\n    color: #999;\n}\n.logoSize[data-v-5308a208]{\n    color: #e03030;\n    text-align: right;\n}\n.logoSizeOk[data-v-5308a208]{\n    color: #509050 !important;\n}\n", ""]);
// Exports
module.exports = exports;
